import PersistentWebSocket from "./persistentWebSocket"
import {getToken} from "./skylineApi"

let globalFeedWS

export const globalFeedEvents = new EventTarget()

function handleGlobalFeedMessage(event) {
  if (!event.detail) {
    console.error("Received an invalid global feed websocket event:", event)
    return
  }

  let message
  try {
    message = JSON.parse(event.detail)
  } catch (err) {
    console.error("Error parsing JSON on global feeed: ", err)
    return
  }

  if (!message.type || !message.data) {
    console.error("Received an invalid global feed message:", event)
    return
  }

  const feedMessageEvent = new CustomEvent(message.type, {detail:message.data})
  globalFeedEvents.dispatchEvent(feedMessageEvent)
}

export async function connect(baseUrl) {
  let globalFeedUrl = (window.location.protocol === "https:" ? "wss://" : "ws://") + baseUrl + "/global_feed"

  console.log("Connecting to ", globalFeedUrl)
  globalFeedWS = new PersistentWebSocket(async () => globalFeedUrl + "?token=" + await getToken())
  globalFeedWS.connect()
  globalFeedWS.addEventListener("message", handleGlobalFeedMessage)
}